import React, { Component } from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceAccordion.css";
import { Accordion, Panel } from "baseui/accordion";
import { withTranslation } from "react-i18next";

class ExperienceAccordion extends Component {
  getSectionTitle(sectionTitle, t) {
    const titleMap = {
      Work: t("experience.sections.work"),
      Internships: t("experience.sections.internships"),
      Volunteerships: t("experience.sections.volunteerships"),
    };
    return titleMap[sectionTitle] || sectionTitle;
  }

  getSectionType(sectionTitle) {
    const sectionMap = {
      Work: "work",
      Internships: "internships",
      Volunteerships: "volunteerships",
    };
    return sectionMap[sectionTitle] || sectionTitle.toLowerCase();
  }

  getExperienceKey(sectionTitle, experienceIndex) {
    const experienceKeys = {
      Work: ["unifonic", "amazon", "cegedim", "orange", "readyApps"],
      Internships: ["oneMillionArabCoders", "zadSolutions"],
      Volunteerships: ["microsoftStudentTech"],
    };
    return (
      experienceKeys[sectionTitle]?.[experienceIndex] ||
      `experience${experienceIndex}`
    );
  }

  render() {
    const theme = this.props.theme;
    const { t } = this.props;
    return (
      <div className="experience-accord">
        <Accordion>
          {this.props.sections.map((section) => {
            return (
              <Panel
                className="accord-panel"
                title={this.getSectionTitle(section["title"], t)}
                key={section["title"]}
                overrides={{
                  Header: {
                    style: () => ({
                      backgroundColor: `${theme.body}`,
                      border: `1px solid`,
                      borderRadius: `5px`,
                      borderColor: `${theme.headerColor}`,
                      marginBottom: `3px`,
                      fontFamily: "Google Sans Regular",
                      color: `${theme.text}`,
                      ":hover": {
                        color: `${theme.secondaryText}`,
                      },
                    }),
                  },
                  Content: {
                    style: () => ({
                      backgroundColor: `${theme.body}`,
                    }),
                  },
                }}
              >
                {section["experiences"].map((experience, index) => {
                  const sectionType = this.getSectionType(section["title"]);
                  const experienceKey = this.getExperienceKey(
                    section["title"],
                    index
                  );
                  return (
                    <ExperienceCard
                      key={`${sectionType}-${experienceKey}`}
                      index={index}
                      totalCards={section["experiences"].length}
                      experience={experience}
                      experienceKey={experienceKey}
                      sectionType={sectionType}
                      theme={theme}
                    />
                  );
                })}
              </Panel>
            );
          })}
        </Accordion>
      </div>
    );
  }
}

export default withTranslation()(ExperienceAccordion);
